module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "vept"
  }, [_vm._v("HALCYON DAYS")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Not from successful love alone,")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Nor wealth, nor honor’d middle age, nor victories of politics or war;")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("But as life wanes, and all the turbulent passions calm,")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("As gorgeous, vapory, silent hues cover the evening sky,")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("As softness, fullness, rest, suffuse the frame, like fresher, balmier air,")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("As the days take on a mellower light, and the apple at last hangs really finish’d and indolent-ripe on the tree,")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Then for the teeming quietest, happiest days of all!")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The brooding and blissful halcyon days!")])]), _vm._v(" "), _c('p', {
    staticClass: "vepc"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("—Walt Whitman, at seventy")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0